import {createSlice, Dictionary, PayloadAction} from '@reduxjs/toolkit'
import {takeEvery, getContext, call, put} from 'typed-redux-saga'
import Activity from 'src/models/Activity'
import {DataState} from 'src/types/dataState.type'
import {shouldLogUserOut} from '../configureStore'
import _ from 'lodash'
import Api from '../../api/reactpt'

export type ActivitiesState = {
  activities: Dictionary<Activity>
  dataState: DataState
}

const initialState: ActivitiesState = {
  activities: {},
  dataState: {state: 'unloaded'},
}

export const {actions, reducer} = createSlice({
  name: 'activities',
  initialState,
  reducers: {
    getActivities: (_state: ActivitiesState, _action: PayloadAction<void>) => {},
    setActivities: (state: ActivitiesState, action: PayloadAction<{activities: Activity[]}>) => {
      const keyed = _.keyBy(action.payload.activities, ({id}) => id)
      const newActivities = {...keyed} as Dictionary<Activity>
      return {...state, activities: newActivities}
    },
    setDataState: (state: ActivitiesState, action: PayloadAction<{dataState: DataState}>) => {
      const {dataState} = action.payload
      return {...state, dataState}
    },
    clear: (_state: ActivitiesState) => {
      return {...initialState}
    },
  },
})

export const getActivitiesSaga = function* () {
  const api: Api = yield* getContext<Api>('api')
  yield* put(actions.setDataState({dataState: {state: 'loading'}}))
  try {
    const result = yield* call(api.getActivities)
    yield* put(actions.setActivities({activities: result}))
    yield* put(actions.setDataState({dataState: {state: 'loaded'}}))
  } catch (error) {
    if (shouldLogUserOut(error)) {
      throw error
    } else {
      yield* put(actions.setDataState({dataState: {state: 'unloaded', error}}))
    }
  }
}

export const saga = function* () {
  yield* takeEvery(actions.getActivities.type, getActivitiesSaga)
}
